"use strict";
(function(global) {
    class DdosMitigationController {
        constructor(config) {
            this.settings = {
                charts: {
                    barChart: {
                        dataName: "column_data",
                        id: "alarms"
                    }
                },
                colors: {
                    low: "250, 220, 0",
                    medium: "255, 132, 51",
                    high: "213, 71, 51"
                }
            };
            this.config = config;
            this.loadDataChart();
            this.createGrid();
        }

        loadDataChart() {
            const loadingDivs = document.querySelectorAll('.loading');
            const cardActions = [];

            for (const div of loadingDivs) {
                const closestCard = div.closest('.card');
                const cardHeaders = closestCard.querySelectorAll('.card-header');

                for (const headerElement of cardHeaders) {
                    const actions = headerElement.querySelectorAll('.actions');
                    cardActions.push(...actions);
                }
            }

            $(document).on('ajaxStart', () => {
                for (const div of loadingDivs) {
                    div.style.display = 'block';
                    div.classList.add('i-am-visible');
                }
                const chartTitleElements = document.querySelectorAll('.chart-title');
                chartTitleElements.forEach(el => el.style.display = 'none');
                cardActions.forEach(el => el.style.opacity = 0);
            });
            $(document).on('ajaxStop', () => {
                for (const div of loadingDivs) {
                    div.classList.add('hide-me');
                    div.addEventListener('transitionend', () => div.style.display = 'none');
                }

                const chartTitleElements = document.querySelectorAll('.chart-title');
                chartTitleElements.forEach(el => el.style.display = 'block');
                cardActions.forEach(el => el.style.opacity = 1);
            });
            const el = document.getElementById('charLinear1');
            const span = el.querySelector('span');
            const div = el.querySelector('div');

            ApiConnect.get(this.config.chart_data_url).then(data => {
                // noinspection JSUnresolvedVariable
                const values = data.data.column_data.values;

                if (Object.keys(values).length === 0 && values.constructor === Object) {
                    span.style.display = 'block';
                } else {
                    div.style.display = 'block';
                    this.drawCharts(data);
                }

                this.setCardHeaders();
            }).catch((errorThrown) => {
                console.log('Błąd wczytywania danych: ', errorThrown);
            }).finally(() => {
                for (const div of loadingDivs) {
                    div.classList.add('hide-me');
                    div.addEventListener('transitionend', () => div.style.display = 'none');
                }

                const chartTitleElements = document.querySelectorAll('.chart-title');
                chartTitleElements.forEach(el => el.style.display = 'block');
                cardActions.forEach(el => el.style.opacity = 1);
            });
        }

        setCardHeaders() {
            const barChartId = this.settings.charts.barChart.id;
            const barChart = document.getElementById(barChartId);
            const barChartCard = barChart.closest('.card');
            const barChartTitleEl = barChartCard.querySelector('.chart-title');
            barChartTitleEl.textContent = this.config["bar_chart_title"];
        }

        drawCharts(data) {
            this.barChart = new NS.Charts.BarChart({
                "container-id": "alarms",
                data: data["data"][this.settings["charts"]["barChart"]["dataName"]],
                multidata: false
            });
        }

        createGrid() {
            const columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
                columnDefinitions: [{
                    label: "Rozpoczęta",
                    dataIndex: "start",
                    dataType: "text",
                    isEditable: false,
                    isSortable: true,
                    isFilterable: true,
                    isMovable: true,
                }, {
                    label: "Zakończona",
                    dataIndex: "finished",
                    dataType: "text",
                    isEditable: false,
                    width: "*"
                }, {
                    label: "Nazwa",
                    dataIndex: "name",
                    dataType: "text",
                    isEditable: false
                }, {
                    label: "Managed object",
                    dataIndex: "managed_object",
                    dataType: "text",
                    isEditable: false
                }, {
                    label: "Alert",
                    dataIndex: "alert",
                    dataType: "text",
                    isEditable: false
                }, {
                    label: "Raport",
                    dataIndex: "report",
                    dataType: "text",
                    isEditable: false
                }, {
                    label: "Akcje",
                    dataIndex: "actions",
                    dataType: "actions",
                    isEditable: false,
                }]
            });

            const dataSource = new NS.Grid.SimpleDataSource({
                url: this.config.table_data_url,
                baseParameters: {},
                updateUrl: "/js/app/update.json"
            });

            const settingsManager = new NS.Grid.CookiesSettingsManager({
                id: "gridContainerId"
            });

            new NS.Grid.Control({
                id: "gridContainerWrapperId",
                containerId: 'grid-container',
                dataSource: dataSource,
                reloadTime: null, //not implemented yet
                autoLoad: true,
                columnDefinitionSource: columnDefinitionSource,
                settingsManager: settingsManager,
                allowMultiselect: false,
                showAllRows: this.config.show_all_rows || false,
                pageSize: (this.config.show_all_rows)? 99999999 : 20,
                listeners: {
                    onDataChanged: () => {},
                    onDataSaved: () => {},
                    onDataInvalid: () => {},
                    onDataError: () => {},
                    onSelectionChange: () => {}
                }
            });
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Views = global.NS.Views || {};
    global.NS.Views.DdosMitigationController = DdosMitigationController || {};

})(window);
